export const ICONS_BASE_PATH = 'assets/icons/countries';

const COUNTRY_JURISDICTIONS = {
  us: ['us-ct', 'us-hi', 'us-id', 'us-ky', 'us-mi', 'us-mo', 'us-mt', 'us-nv', 'us-nj', 'us-ny', 'us-vt', 'us-wa', 'us-ca'],
  ua: ['ua-14', 'ua-43', 'ua-63', 'ua-65', 'ua-09', 'ua-48', 'ua-23'],
  ca: ['ca-ab', 'ca-bc', 'ca-mb', 'ca-on', 'ca-qc'],
} as const;

export const COUNTRY_JURISDICTION_ICON_BY_CODE = new Map<string, string>(
  Object.entries(COUNTRY_JURISDICTIONS).flatMap(([iconName, jurisdictions]) =>
    jurisdictions.map((jurisdiction): [string, string] => [jurisdiction, iconName]),
  ),
);
